import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { CookieService } from 'ngx-cookie-service'

import { MenuService } from 'app/services/menu.service'

@Component({
  selector: 'app-customers-agent',
  templateUrl: './customers-agent.component.html',
  styleUrls: ['./customers-agent.component.scss']
})
export class CustomersAgentComponent implements OnInit {

  url

  constructor(
    private http: HttpClient,
    private menuService: MenuService,
    private cookies: CookieService,
  ) { }

  ngOnInit() {
    this.url = this.menuService.getScreen('CUSTOMERAGENT', true).url+this.cookies.get('at') + '&mode='+(localStorage.getItem('theme') == 'grey' ? 'light' : 'dark')
  }
}
